<template>
  <b-col cols="auto">
    <span
      @click="showAll()"
      v-if="showConfigurationLabel"
      class="list-aggregator__configuration-label text-lowercase"
    >
      <label class="list-aggregator__configuration-label">
        {{ modalTableItems.length }}
      </label>
      {{ $t(configurationLabel) }}
    </span>
    <span
      v-else
      class="list-aggregator"
    >
      <span
        v-if="nameColumn === 'ativo'"
        @click="showAll()"
        class="text-blue list-aggregator__show-all-link"
      >
        {{ visibleItemsList }}
      </span>

      <span v-else>{{ visibleItemsList }}</span>

      <template v-if="showSuppressedLabel">
        {{ $t('list-aggregator.and') }}
        <span
          @click="showAll()"
          class="text-blue list-aggregator__show-all-link"
        >
          {{ $t('list-aggregator.plus', { count: suppressedItemsLength }) }}
          {{ $tc(suppressedLabelPath, suppressedItemsLength) }}
        </span>
      </template>
    </span>
    <suppressed-items-modal
      v-model="suppressedItemsModalShow"
      :sort="sort"
      :modal-table-items="modalTableItemsCopy"
      :modal-title="modalTitle"
      :modal-table-headers="modalTableHeaders"
      :modal-item-name-keys="modalItemNameKeys"
      :modal-item-id-key="modalItemIdKey"
      :configuration-mode="configurationMode"
      :is-paginated="isPaginated"
      :per-page="perPage"
      :custom-modal-size="customModalSize"
      :is-html="isHtml"
      :multipleColumns="multipleColumns"
      @update-selection="updateSelection"
    />
  </b-col>
</template>

<script>
import SuppressedItemsModal from './SuppressedItemsModal';

export default {
  name: 'ListAggregator',
  components: {
    SuppressedItemsModal,
  },
  props: {
    configurationMode: {
      type: Boolean,
      default: false,
    },
    configurationLabel: {
      type: String,
      default: 'general.selected-records',
    },
    visibleItems: {
      type: Number,
      default: 1,
    },
    separator: {
      type: String,
      default: ', ',
    },
    modalTableItems: {
      type: Array,
      required: true,
    },
    modalItemNameKey: {
      type: [String, Array],
      default: () => 'name',
    },
    modalItemIdKey: {
      type: String,
    },
    modalTitle: {
      type: String,
      required: true,
    },
    modalTableHeader: {
      type: [String, Array],
      required: true,
    },
    suppressedLabelPath: {
      type: String,
    },
    sort: {
      type: String,
      default: 'asc',
    },
    isPaginated: {
      type: Boolean,
      default: false,
    },
    perPage: {
      type: Number,
      default: 15,
    },
    customModalSize: {
      type: String || null,
      default: null,
    },
    isHtml: {
      type: Boolean,
      default: false,
    },
    multipleColumns: {
      type: Boolean,
      default: false,
    },
    nameColumn: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    suppressedItemsModalShow: false,
  }),
  computed: {
    modalItemNameKeys() {
      return typeof this.modalItemNameKey === 'string' ? [this.modalItemNameKey] : this.modalItemNameKey;
    },
    modalTableHeaders() {
      return typeof this.modalTableHeader === 'string' ? [this.modalTableHeader] : this.modalTableHeader;
    },
    showConfigurationLabel() {
      return this.configurationMode && (this.modalTableItems || []).length;
    },
    showSuppressedLabel() {
      return this.suppressedItemsLength > 0;
    },
    itemsLabelHandler() {
      return (this.modalTableItems || []).map(item => item[this.modalItemNameKey]);
    },
    visibleItemsList() {
      return this.itemsLabelHandler
        ? this.itemsLabelHandler.slice(0, this.visibleItems)
          .join(this.separator)
        : null;
    },
    suppressedItemsLength() {
      return this.itemsLabelHandler && this.itemsLabelHandler.length > this.visibleItems
        ? this.itemsLabelHandler.length - this.visibleItems
        : 0;
    },
    modalTableItemsCopy() {
      return [...this.modalTableItems];
    },
  },
  methods: {
    updateSelection(items) {
      this.$emit('update-selection', items);
      this.$emit('update:modal-table-items', items);
    },
    showAll() {
      this.suppressedItemsModalShow = true;
    },
  },
};
</script>

<style lang="sass" scoped>
  .list-aggregator
    &__configuration-label
      text-decoration: underline
      color: var(--color-secondary)
      cursor: pointer
    &__show-all-link
      text-decoration: underline
      cursor: pointer
</style>
